import { useEffect } from 'react'

export function useScrollReveal() {
  useEffect(() => {
    let observer: IntersectionObserver | null = null
    const timer = setTimeout(() => {
      const els = document.querySelectorAll('[data-sr]')
      observer = new IntersectionObserver(
        entries =>
          entries.forEach(e => {
            if (e.isIntersecting) {
              const delay = Number((e.target as HTMLElement).dataset.delay ?? 0)
              setTimeout(() => e.target.classList.add('sr-on'), delay)
              observer!.unobserve(e.target)
            }
          }),
        { threshold: 0.12 }
      )
      els.forEach(el => observer!.observe(el))
    }, 80)
    return () => {
      clearTimeout(timer)
      observer?.disconnect()
    }
  }, [])
}
